<script setup lang="ts">
import type { CompId } from "@shared/comp";

const props = defineProps<{
  entryCount: number;
  daysUntilKickoff: number | null;
  compId: CompId;
}>();
</script>

<template>
  <header class="border-b border-slate-200 pb-5 mb-6">
    <div class="flex items-center gap-3">
      <img v-if="props.compId !== 2" src="/kfc-logo.png" alt="Killearn FC" class="h-10 w-auto select-none" />
      <h1 class="text-2xl sm:text-3xl font-extrabold tracking-tight bg-gradient-to-r from-pot1 via-amber-500 to-pot3 bg-clip-text text-transparent">
        World Cup 2026 Sweepstake
      </h1>
    </div>
    <p class="mt-2 text-sm text-slate-600 tabular flex flex-wrap gap-x-3 gap-y-1 items-center">
      <span>{{ props.entryCount }} {{ props.entryCount === 1 ? 'entry' : 'entries' }}</span>
      <template v-if="props.daysUntilKickoff !== null">
        <span class="text-slate-400">·</span>
        <span>{{ props.daysUntilKickoff }} day{{ props.daysUntilKickoff === 1 ? '' : 's' }} to kickoff</span>
      </template>
    </p>
  </header>
</template>
